import PrefixEnum from '../prefixes'

export default Object.freeze({
    'dianne-buswell.gymondo.fitness': PrefixEnum.DANCE_WORKS,
})
